<template>
  <div class="page-content container">
    <h1 class="text-2xl font-semibold text-primary leading-8">
      {{ $t('title') }}
    </h1>

    <div class="flex flex-col md:flex-row mt-4">
      <div class="w-full md:pr-10 md:py-4 space-y-4">
        <p>
          {{ $t('body-1') }}
        </p>

        <p>
          {{ $t('body-2') }}
        </p>

        <p>
          {{ $t('body-3') }}
        </p>
      </div>
      <div
        class="flex flex-col items-center md:items-start md:justify-center w-full border-y border-y-primary mt-8 md:mt-0 md:pl-10 md:border-y-0 md:border-l md:border-l-primary py-8"
      >
        <i18n
          tag="h1"
          path="cta-title"
          class="text-block text-center md:text-left font-semibold text-4xl leading-12"
        >
          <template #service>
            <span class="text-primary">
              {{ $t('cta-title-service') }}
            </span>
          </template>
        </i18n>

        <TBtnLink
          id="linkToHomepage"
          class="bg-primary hover:bg-primary-dark mt-10"
          href="/"
        >
          {{ $t('cta-button') }}
        </TBtnLink>
      </div>
    </div>

    <h2 class="text-lg leading-6 text-primary font-semibold mt-8">
      {{ $t('block-1-title') }}
    </h2>
    <p class="mt-4">
      {{ $t('block-1-body') }}
    </p>

    <h2 class="text-lg leading-6 text-primary font-semibold mt-8">
      {{ $t('block-2-title') }}
    </h2>
    <p class="mt-4">
      {{ $t('block-2-body') }}
    </p>

    <h2 class="text-lg leading-6 text-primary font-semibold mt-8">
      {{ $t('block-3-title') }}
    </h2>
    <p class="mt-4">
      {{ $t('block-3-body') }}
    </p>
    <i18n path="block-3-body-1" tag="p" class="mt-4">
      <template #linkToHomepage>
        <TBtnLink class="m-0 p-0 text-primary hover:underline h-auto" to="/">
          {{ $t('block-3-body-1-link-text') }}
        </TBtnLink>
      </template>
    </i18n>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: 'Op zoek naar een makelaar?',
      headDescription:
        'Binnenkort je huis verkopen? Door makelaars te vergelijken is het mogelijk om de beste makelaar te vinden die qua service en kosten volledig bij je past.',
      path: '/informatie-over-makelaars',
    }
  },
}
</script>

<i18n>
{
  "nl-NL": {
    "title": "Informatie over makelaars",
    "body-1": "De waardebepaling voor je huis kan op verschillende manieren worden uitgevoerd. Afhankelijk van het doel van de waardebepaling kun je ervoor kiezen om een makelaar in armen te nemen die een taxatie uitvoert.",
    "body-2": "Door de vergelijking van verschillende makelaars in je regio kun je er zeker van zijn dat je een makelaar vind die optimaal bij jouw wensen past.",
    "body-3": "De waardebepaling is gratis, omdat de makelaar hiermee direct zijn/haar expertise kan tonen: je krijgt duidelijkheid over de huidige waarde van de woning en inzicht in manieren om de woningwaarde te verhogen. Mocht je de woning willen verkopen, dan hoopt de makelaar je daar uiteraard bij te mogen helpen. Na de waardebepaling ben je hoe dan ook nergens toe verplicht (volledig vrijblijvend).",
    "cta-title": "Krijg je {service} van een makelaar",
    "cta-title-service": "gratis waardebepaling",
    "cta-button": "Vraag nu een gratis waardebepaling aan",
    "block-1-title": "Wat doet een makelaar",
    "block-1-body": "Een makelaar is opgeleid om mensen te begeleiden bij de koop of verkoop van een huis of bedrijfspand. De makelaar heeft daarbij tot taak om het gehele proces te begeleiden. Indien gewenst kan de makelaar specifiek op zoek gaan naar geschikte woon- of bedrijfsruimte, er kan een taxatie gedaan worden en de makelaar kan advies uitbrengen omtrent de af te sluiten hypotheek. Daarnaast is de makelaar ook bevoegd om zich bezig te houden met de bemiddeling van commercieel vastgoed. Een andere taak die eveneens door een makelaar vervuld kan worden is die van adviseur voor de gemeente en woningbouwvereniging. De makelaar is bevoegd om advies te geven omtrent nieuwbouw, renovatie, onteigening en verbouwing.",
    "block-2-title": "Makelaar vergelijken",
    "block-2-body": "Het is raadzaam om de verschillende diensten van makelaars te vergelijken. Niet elke makelaar hanteert dezelfde service. Bij het vergelijken van makelaars is het handig om niet alleen naar de verschillen in prijs en eventueel de aangeboden diensten te kijken, maar ook ervaringen van anderen kunnen van cruciaal belang zijn om de juiste keuze te kunnen maken. Het vergelijken kan in alle rust thuis of op kantoor gebeuren, waarbij via diverse opties de beste makelaar voor uw situatie gevonden kan worden.",
    "block-3-title": "Kosten makelaar",
    "block-3-body": "Een makelaar is bevoegd zelfstandig te werken, maar kan ook in loondienst zijn van een makelaarskantoor. Ongeacht of de makelaar zelfstandig of in dienstverband werkzaam is, aan het inschakelen van een makelaar zijn kosten verbonden. De kosten van een makelaar bestaan uit een bepaald percentage van de koopprijs. In veel gevallen zijn de makelaarskosten echter ook onderhandelbaar. De kosten worden alleen in rekening gebracht indien de koop of verkoop daadwerkelijk plaats heeft gevonden. Eventueel bijkomende kosten kunnen bestaan uit advertentiekosten.",
    "block-3-body-1": "De voordeligste makelaar in jouw regio vind en vergelijk je via de gratis offertetool op deze pagina. Vul je postcode in en vraag {linkToHomepage} aan van makelaars in jouw regio.",
    "block-3-body-1-link-text": "gratis vrijblijvende offertes"
  },
  "en-GB": {
    "title": "Information about brokers",
    "body-1": "After you get a free valuation you might decide to hire an expert broker to do an appraisal of your house. Then it is advisable to call in an expert who can optimally guide you in the purchase or sale of a new home.",
    "body-2": "By comparing brokers, it is possible to find the best broker who fully meets your wishes and requirements in terms of service and costs.",
    "body-3": "By comparing brokers, you immediately know what to expect in brokerage costs and you will not be faced with any unwanted surprises.",
    "cta-title": "Get your {service} from an expert",
    "cta-title-service": "free house valuation",
    "cta-button": "Get a free valuation now",
    "block-1-title": "What does a broker do",
    "block-1-body": "A broker is trained to guide people in the purchase or sale of a house or business property. The broker's task is to supervise the entire process. If desired, the broker can specifically look for suitable residential or commercial space, an appraisal can be done and the broker can advise on the mortgage to be taken out. In addition, the broker is also authorized to deal with the mediation of commercial real estate. Another task that can also be fulfilled by a real estate agent is that of advisor for the municipality and housing association. The estate agent is authorized to advise on new construction, renovation, expropriation and renovation.",
    "block-2-title": "Compare broker",
    "block-2-body": "It is advisable to compare the different services of brokers. Not every broker offers the same service. When comparing brokers, it is useful not only to look at the differences in price and possibly the services offered, but also the experiences of others can be crucial to make the right choice. The comparison can be done in peace at home or at the office, whereby the best broker for your situation can be found via various options.",
    "block-3-title": "Broker fees",
    "block-3-body": "A broker is authorized to work independently, but can also be employed by a brokerage firm. Regardless of whether the broker is self-employed or employed, there are costs associated with engaging a broker. The costs of a broker consist of a certain percentage of the purchase price. However, in many cases the brokerage fees are also negotiable. The costs will only be charged if the purchase or sale has actually taken place. Any additional costs may consist of advertising costs.",
    "block-3-body-1": "You can find and compare the cheapest broker in your region using the free quote tool on this page. Enter your zip code and request{linkToHomepage}from brokers in your region.",
    "block-3-body-1-link-text": "free quotes"
  }
}
</i18n>
